export const getActionType = (entityId?: string): string => {
  const separator = entityId?.includes('.') ? '.' : '-';
  return entityId ? entityId.split(separator)[0] : '';
}

export const getActionKey = (entityId?: string, truncEnding?: string): string => {
  const separator = entityId?.includes('.') ? '.' : '-';
  const key = entityId ? entityId.split(separator)[1] : '';
  return key.length && truncEnding?.length ? key.substring(0, key.indexOf(truncEnding)) : key;
}

export const getDevicePath = (entityId?: string): string[] => {
  if (entityId?.includes('_')) {
    const path = entityId?.includes('-') ? entityId.split('-')[1] : entityId;
    return path.split('_');
  }
  return [];
}
